module.exports = __webpack_public_path__ + "img/nom_small.9238cc0a.jpg";